import React, { useEffect, useState } from "react";
import _ from "lodash";

function ExpandaleRowView({ record }) {
  const [prescriptionStore, setPrescriptionStore] = useState([]);
  const [prescriptionStoreTraya, setPrescriptionStoreTraya] = useState([]);
  const [prescriptionStoreTest, setPrescriptionStoreTest] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(record?.prescription)) {
      const prescriptionData = record?.prescription || [];
      const internalPrescription = [];
      const externalPrescription = [];
      const testPrescription = [];
      _.forEach(prescriptionData, (prescription) => {
        const prescriptionLength = Object.keys(prescription).length;
        if (prescriptionLength === 4) {
          externalPrescription.push(prescription);
        } else if (prescriptionLength >= 3) {
          internalPrescription.push(prescription);
        } else {
          testPrescription.push(prescription);
        }
      });
      setPrescriptionStore(externalPrescription);
      setPrescriptionStoreTraya(internalPrescription);
      setPrescriptionStoreTest(testPrescription);
    } else {
      setPrescriptionStore([]);
      setPrescriptionStoreTraya([]);
      setPrescriptionStoreTest([]);
    }
  }, [record?.prescription]);

  return (!prescriptionStoreTraya?.length &&
    !prescriptionStoreTest?.length &&
    !prescriptionStore?.length) ? (
    <div className="font-poppins">Prescription is not written Yet</div>
  ) : (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex flex-column gap-2">
        <div className="fw-bold font-poppins">Traya Internal Prescription</div>
        <div>
          {prescriptionStoreTraya?.map((item) => {
            return (
              <div className="d-flex flex-row gap-2">
                <span>Prescription : {item.prescription} ,</span>
                <span>Dosage : {item.dosage} ,</span>
                <span>Comment : {item.comment}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex flex-column gap-2">
        <div className="fw-bold font-poppins">Traya External Prescription</div>
        <div>
          {prescriptionStore?.map((item) => {
            return (
              <div className="d-flex flex-row gap-2">
                <span>Prescription : {item.prescription} ,</span>
                <span>Dosage : {item.dosage} ,</span>
                <span>Comment : {item.comment}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex flex-column gap-2">
        <div className="fw-bold font-poppins">Traya Test</div>
        <div>
          {prescriptionStoreTest?.map((item) => {
            return <div className="">Test : {item.test}</div>;
          })}
        </div>
      </div>
    </div>
  );
}

export default ExpandaleRowView;
